/**
 * @description Checks if the string is a valid URL with http or https protocol, a valid hostname, and optionally checks for TLD presence.
 * @param {string} value
 */
export function isValidUrl(value) {
  if (typeof value !== 'string') {
    return false;
  }
  try {
    const url = new URL(value);
    if (!['http:', 'https:'].includes(url.protocol)) {
      return false;
    }
    if (!url.hostname) {
      return false;
    }
    // Check the raw text: URL() turns a bare origin's path into '/'
    if (value.endsWith('/')) {
      return false;
    }
    const parts = url.hostname.split('.');
    const regex = /^(localhost|(\d{1,3}\.){3}\d{1,3})$/;
    if (parts.length < 2 && !regex.test(url.hostname)) {
      return false;
    }
    return true;
  } catch (_) {
    return false;
  }
}
